import {useTheme} from "@emotion/react";
import {Slide, Slider} from "@/components/Slider";
import {SliderWrapper} from "@/components/sections/B16Articles/styles";
import TitleUnderlinedAnimated from "@/elements/TitleUnderlinedAnimated";
import type {SectionQuestionAnswer} from "@/generated/api";
import SectionWrapper from "@/layouts/SectionWrapper";
import QuestionCard from "./QuestionCard";
import {CardsWrapper, InnerWrapper} from "./styles";

interface B18QuestionsProps {
  sectionData: SectionQuestionAnswer;
  isFirstSection?: boolean;
  isLastSection?: boolean;
  id?: string;
}

const B18Questions = ({
  sectionData,
  isFirstSection,
  isLastSection,
  id: _id,
}: B18QuestionsProps) => {
  const {questions, bg_color, title} = sectionData;
  const {breakpoints} = useTheme();
  const {isMobile} = breakpoints;

  return (
    <SectionWrapper
      backgroundColor={bg_color}
      isFirstSection={isFirstSection}
      isLastSection={isLastSection}
      innerWrapperStyles={{overflow: "visible"}}
    >
      {questions && (
        <InnerWrapper>
          {title && (
            <TitleUnderlinedAnimated wrapperStyles={{marginBottom: isMobile ? 5 : 35}}>
              {title}
            </TitleUnderlinedAnimated>
          )}

          {isMobile ? (
            <SliderWrapper backgroundColor={bg_color}>
              <Slider
                key={0}
                spaceBetween={15}
                scrollbar={{draggable: !isMobile, dragSize: "auto"}}
                style={{paddingBottom: 40, paddingLeft: "-10px", overflow: "visible"}}
              >
                {questions?.map((card, i) => (
                  <Slide key={i} style={{width: "fit-content"}}>
                    <QuestionCard cardData={card} />
                  </Slide>
                ))}
              </Slider>
            </SliderWrapper>
          ) : (
            <CardsWrapper>
              {questions?.map((card, i) => (
                <QuestionCard key={i} cardData={card} />
              ))}
            </CardsWrapper>
          )}
        </InnerWrapper>
      )}
    </SectionWrapper>
  );
};

export default B18Questions;
